// extracted by mini-css-extract-plugin
module.exports = {"list":"SolutionsList_list__2NdZO","list__image":"SolutionsList_list__image__AbjrJ","list__title":"SolutionsList_list__title__jUZwZ","list__text":"SolutionsList_list__text__1dj4o"};